






import { defineComponent } from "@vue/composition-api";
import { Actions } from "./store";
import { mapActions } from "vuex";
import authService from "@/services/auth.service";

export default defineComponent({
  name: "App",
  created() {
    this.$store.watch(
      (state) => state.toastMessages,
      (toastMessages) => {
        const lastMessage = toastMessages.slice(-1)[0];
        this.$toast.error(lastMessage);
      }
    );
  },
  beforeUpdate() {
    if (authService.isAuthenticated()) {
      this.fetchFederations();
    }
  },
  methods: {
    ...mapActions([Actions.FETCH_FEDERATIONS]),
  },
});
